/* eslint-disable react-hooks/exhaustive-deps */
import { useLocation } from 'react-router-dom';
import Preview from './preview';
import { gql, useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';

const Q_IDS = gql`
	query getNpIdsInRelationByRelationId($relationId: String!) {
		getNpIdsInRelationByRelationId(relationId: $relationId)
	}
`;

function RelationPopout() {
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const id = urlParams.get('id') || null;
	const [getNpIdsInRelationByRelationId, { data }] = useLazyQuery(Q_IDS);

	useEffect(() => id && load(), [id]);

	function load() {
		getNpIdsInRelationByRelationId({ variables: { relationId: id } });
	}

	return (
		<>
			{data?.getNpIdsInRelationByRelationId?.map((npId, i) => (
				<Preview id={npId} showButton={i === 0} />
			))}
		</>
	);
}

export default RelationPopout;
